function toggleShippingSection() {
  let shippingDetails = $("#order-shipping-details")
  let physicalGiftcard = $("#physical").hasClass("active")
  let vippsPaymentMethod = $("#order_payment_method_vipps:checked").length > 0

  if (physicalGiftcard && vippsPaymentMethod) {
    shippingDetails.show()
  } else {
    shippingDetails.hide()
  }
}

$(function () {
  $('input[name="order[type]"]').on("click", function () {
    let targetTab = $("#" + this.dataset.target)
    $(".tab-pane.active").removeClass("active")
    $(targetTab).toggleClass("active")
    toggleShippingSection()
  })

  $('input[name="order[payment_method]"]').on("click", function () {
    toggleShippingSection()
  })
})
